import { createFileRoute } from "@tanstack/react-router"

import { seoMeta } from "@/lib/seo"

import { SitemapPage } from "./-components/SitemapPage"
import { sitemapMeta } from "./-data/sitemap-meta"

export const Route = createFileRoute("/sitemap/")({
  head: () => seoMeta(sitemapMeta),
  component: SitemapPage,
})
